const generateJSONHeaderNoXsrf = () => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  return headers;
};

export default generateJSONHeaderNoXsrf;
